import React,{useState,useEffect} from 'react'
import { Container, Row , Col} from 'react-bootstrap'
import img from '../../assets/2.PNG';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';



const Thirdsec = () => {
    const [partner, setpartner] = useState([]);

    const fetchpartnerpage = async () => {
        const response = await fetch(`${process.env.REACT_APP_BACKEND}/api/get-registeredfunds`);
        const result = await response.json();
        setpartner(result);
      };
      useEffect(() => {
          fetchpartnerpage();
      }, []);
  return (

    <section className='refunds-service-sec-3'>
       <Container>
                <Row>
                    <Col md={7} className="py-5">
                    {partner.map((row, index) => (

<>
<h1>{row.thirdheading}</h1>
<p>
{ReactHtmlParser(row.thirddesc)}

</p>
<Link to={row.ctabutton}>
<Button variant="outline-light my-5" className="blue-btn ">GET FUND COMPLIANCE HELP</Button></Link>
</>
))}
                    </Col>
                    <Col md={5}>
                        <img className='about-intro-img' src={img}/>
                    </Col>
                </Row>
            </Container>
    </section>

    )
}

export default Thirdsec